import { AppBundle } from 'api/optimalprint-sdk.d';

const getBundleGroups = (
  productId: number | undefined,
  abstractProduct: AppBundle.Api.Entity.App.V1.IAbstractProduct | undefined,
): AppBundle.Api.Entity.App.V1.AbstractProduct.IBundleGroup[] => {
  if (!productId || !abstractProduct || !abstractProduct.products) {
    return [];
  }
  const targetProduct = abstractProduct.products.find((productItem) => productItem.productId === productId);
  return targetProduct?.bundleGroups || [];
};

export default getBundleGroups;
